import { render, staticRenderFns } from "./MailInspectionModal.vue?vue&type=template&id=a1d84270&"
import script from "./MailInspectionModal.vue?vue&type=script&lang=js&"
export * from "./MailInspectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports